import * as React from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'rounded-full border-transparent bg-black-950 text-white hover:bg-black-900',
        secondary:
          'rounded bg-secondary-300 text-black-950 border-transparent hover:bg-secondary-400',
        destructive: 'rounded border-transparent bg-error-500 text-white hover:bg-error-400',
        outline:
          'rounded border-black-200 bg-white text-black-700 dark:border-[var(--fb-border)] dark:bg-[var(--fb-surface)] dark:text-[var(--fb-text-secondary)]',
        soft: 'rounded border-transparent bg-primary-50 text-primary-600 dark:bg-[var(--fb-accent-soft)] dark:text-[var(--fb-accent-text)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
